import React from "react";
import { complianceColor } from "@/lib/constants";
import { cn } from "@/lib/utils";

export function ComplianceBar({ pct, showLabel = true, height = "h-2.5", className }) {
  const c = complianceColor(pct);
  return (
    <div className={cn("w-full", className)}>
      {showLabel && (
        <div className="mb-1 flex items-center justify-between text-xs font-semibold">
          <span className="text-slate-500">Cumplimiento</span>
          <span className={c.text}>{pct}%</span>
        </div>
      )}
      <div className={cn("w-full overflow-hidden rounded-full bg-slate-100", height)}>
        <div
          className={cn("h-full rounded-full transition-all duration-500", c.bar)}
          style={{ width: `${Math.max(pct, 2)}%` }}
        />
      </div>
    </div>
  );
}

export function ComplianceRing({ pct, size = 120 }) {
  const c = complianceColor(pct);
  const stroke = 10;
  const r = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const offset = circ - (pct / 100) * circ;
  const colorHex = { verde: "#10b981", azul: "#3b82f6", amarillo: "#eab308", rojo: "#ef4444" }[c.key];
  return (
    <div className="relative inline-flex items-center justify-center" data-testid="compliance-ring">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="#e2e8f0" strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke={colorHex}
          strokeWidth={stroke}
          fill="none"
          strokeDasharray={circ}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.6s ease" }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className={cn("text-3xl font-bold font-heading", c.text)}>{pct}%</span>
        <span className="text-[11px] font-semibold text-slate-400">{c.label}</span>
      </div>
    </div>
  );
}
